<template>
<div class="chapter">
<div class="inner_page">
<p class="txc" id="pz3-1" style="margin-left: 20%; margin-right: 20%; margin-top: 50%;">
<i>This book is dedicated to my mother, Mary Elizabeth Martin, who taught me the value
					of books before I knew how to read, turn on a television, and locate the front door
					of my kindergarten classroom.</i> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4a4814de